import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export const actionTypes = {
	Login: '[Login] Action',
	Logout: '[Logout] Action',
	SetResetPasswordCode: '[SetResetPasswordCode] Action',
	UserRequested: '[Request User] Action',
	UserLoaded: '[Load User] Auth API',
};

const initialAuthState = {
	user: undefined,
	authToken: undefined,
	userLoading: true,
	userFulfilled: false,
	resetPassword: { email: '', code: '' },
};

export const reducer = persistReducer(
	{ storage, key: 'demo1-auth', whitelist: ['authToken'] },
	(state = initialAuthState, action) => {
		switch (action.type) {
			case actionTypes.Login: {
				const { token, user, userFulfilled } = action.payload;
				return { authToken: token, user, userLoading: false, userFulfilled };
			}

			case actionTypes.SetResetPasswordCode: {
				const resetPassword = action.payload;
				return { ...state, resetPassword };
			}

			case actionTypes.Logout: {
				return { ...initialAuthState, userLoading: false };
			}

			case actionTypes.UserLoaded: {
				const user = action.payload;
				return {
					...state,
					user,
					userLoading: false,
					authToken: user ? state.authToken : null,
					userFulfilled: true
				};
			}

			default:
				return state;
		}
	}
);

export const actions = {
	login: (payload) => ({ type: actionTypes.Login, payload }),
	logout: () => ({ type: actionTypes.Logout }),
	setResetPasswordCode: (payload) => ({ type: actionTypes.SetResetPasswordCode, payload }),
	requestUser: () => ({ type: actionTypes.UserRequested }),
	fulfillUser: (payload) => ({ type: actionTypes.UserLoaded, payload }),
};
